import React from "react";

const SubmitButton = ({
  className = "py-18 px-40",
  type = "submit",
  title = "Submit",
  children,
  isSubmitting,
}) => {
  return (
    <button type={type} className={`btn btn-main ${className}`}>
      {isSubmitting ? <div className="loader" /> : children ? children : title}
    </button>
  );
};

export default SubmitButton;
